import React, { useEffect, useState } from 'react';

import { hasRoles, EDIT_STUDY_ROLES } from '../../../../util/RoleUtil';

import { Table } from '../../../common/table/Table';

import './StudyTrialParticipants.css';

export const StudyTrialParticipants = ({ context, setContext, navigateToWith, study }) => {
  const [searchResults, setSearchResults] = useState([]);
  const [headerTitle, setHeaderTitle] = useState('');

  useEffect(() => {
    setHeaderTitle('Participants - ' + study?.protocolID + ': ' + study.studyName + ' - ' + study?.facility);

    if (study && study?.participants) {
      setSearchResults(
        study.participants.map((participant) => ({
          participantExternalReference: participant.participantExternalReference,
          id: participant.id,
          idType: participant.idType,
          lastVisitCode: participant.lastVisitCode,
          lastVisitType: participant.lastVisitType,
          lastVisitDate: participant.lastVisitDate,
          openQueries: participant.openQueries,
          participantStatus: participant.participantStatus,
        }))
      );
    }
  }, [study]);

  const handleRowClick = async (participant) => {
    const { participantExternalReference } = participant;
    navigateToWith('participantEdit', 'participantClientDetails', { participantExternalReference });
  };

  const handleAddButtonClick = () => {
    setContext((prevState) => ({
      ...prevState,
      canNavigateBack: true,
      navigateContext: study,
      activeTab: 'studyTrialParticipants',
      viewStack: [...context.viewStack],
    }));
    navigateToWith('participantsLinkNew', null, { ...study });
  };

  return (
    <div className="study-trial-participants">
      {searchResults && (
        <Table
          tableData={searchResults}
          hiddenColumns={['participantExternalReference']}
          searchEnabled={true}
          filterEnabled={true}
          onRowClick={handleRowClick}
          tableTitle={headerTitle}
          buttonText={hasRoles(context, EDIT_STUDY_ROLES) ? 'Add New' : undefined}
          onButtonClick={handleAddButtonClick}
          buttonOneWidth={'135px'}
          buttonDisabled={false}
          maxRowCount={7}
          horizontalScroll
        />
      )}
    </div>
  );
};
